import locale from '@/locale/index'
export const getDayName = (dateStr) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  return days[new Date(dateStr).getDay()]
}

export const getMonthName = (dateStr) => {
  try {
    const monthNumber = new Date(dateStr).getMonth()
    return locale.months[monthNumber]
  } catch (e) {
    console.log(e)
    return ''
  }
}
